import { useDispatch } from "react-redux";
import { Typography, Box, Stack, styled, Grid } from "@mui/material";
import dayjs from "dayjs";
import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { setSurveyQuestionDetails } from "redux/features/survey/questions/surveyQuestionSlice";

export const TagValueCombo = (props) => {
  const { label, value, styles = {} } = props;
  return (
    <Stack gap={1} sx={styles}>
      <Typography sx={{ color: "#848484", fontWeight: 400, fontSize: "14px" }}>
        {label}
      </Typography>
      <Typography sx={{ color: "#2E2C34", fontWeight: 600, fontSize: "16px" }}>
        {value}
      </Typography>
    </Stack>
  );
};

const StyledBox = styled(Box)(({}) => ({
  border: "1px solid #E9E9E9",
  borderRadius: "4px",
  padding: "16px",
  height: "100%",
}));

const SurveyQuestionDetails = () => {
  const dispatch = useDispatch();
  const location = useLocation();
  const { state } = location;
  const { surveyQuestionDetails } = state || {};
  const { question_id, question, choices, updated_on, updated_by } =
    surveyQuestionDetails || {};
  useEffect(() => {
    dispatch(setSurveyQuestionDetails(surveyQuestionDetails));
  }, [surveyQuestionDetails]);
  return (
    <Box>
      <Typography sx={{ marginBottom: "1rem" }}>
        Question ID: {question_id}
      </Typography>
      <StyledBox>
        <TagValueCombo label="Question Title" value={question} />
      </StyledBox>
      <Grid sx={{ marginBlock: "1rem" }} container spacing={1}>
        {choices?.map((choice, index) => (
          <Grid
            item
            xs={12}
            sm={6}
            md={choices.length === 2 ? 6 : choices.length === 3 ? 4 : 3}
            key={index}>
            <StyledBox>
              <TagValueCombo
                label={`Answer Option ${index + 1}`}
                value={choice}
              />
            </StyledBox>
          </Grid>
        ))}
        <Grid item xs={12} sm={6} md={2}>
          <StyledBox>
            <TagValueCombo
              label={`Updated On`}
              value={dayjs(updated_on).format(`MM/DD/YYYY, HH:mm`)}
            />
          </StyledBox>
        </Grid>
        <Grid item xs={12} sm={6} md={5}>
          <StyledBox>
            <TagValueCombo label={`Updated By`} value={updated_by} />
          </StyledBox>
        </Grid>
      </Grid>
    </Box>
  );
};
export default SurveyQuestionDetails;
